import CommonFormProvider from "src/context/Modal/Form/CommonForm.provider";
import CheckPromotion from "../_CheckPromotion";
import { Dispatch, SetStateAction } from "react";
import AskPromotionNew from "./AskPromotionNew";
import { useTranslation } from "react-i18next";

interface IDspPromotionUIProps {
  promotionCode: string;
  setPromotionCode: Dispatch<SetStateAction<string>>;
  isCheckPromotionCode: string;
  setIsCheckPromotionCode: Dispatch<SetStateAction<string>>;
  promotionApply: ({
    issueAppList,
    referralId,
    promotionCode,
  }: {
    issueAppList: string[];
    referralId: string;
    promotionCode: string;
  }) => void;
  productName: string;
  toggleAskPromotionOn: boolean;
  setToggleAskPromotionOn: Dispatch<SetStateAction<boolean>>;
}
const FiresidePromotionUI = ({
  promotionCode,
  setPromotionCode,
  isCheckPromotionCode,
  setIsCheckPromotionCode,
  promotionApply,
  productName,
  toggleAskPromotionOn,
  setToggleAskPromotionOn,
}: IDspPromotionUIProps) => {
  const { t } = useTranslation();
  return (
    <div className="containerBox">
      <div className="container">
        <div className="site">
          <h3 className="site__title">
            {!toggleAskPromotionOn
              ? productName + " Cloud Premium"
              : t("siteType.premium.askTitle")}
          </h3>
          <p className="site__desc">
            {!toggleAskPromotionOn
              ? t("siteType.premium.subTitle")
              : t("siteType.premium.askSubTitle")}
          </p>
          <div>
            {toggleAskPromotionOn ? (
              <>
                {/* 문의하기 */}
                <AskPromotionNew
                  setToggleAskPromotionOn={setToggleAskPromotionOn}
                />
              </>
            ) : (
              <CommonFormProvider>
                {/* 프리미엄 코드 등록 */}
                <CheckPromotion
                  promotionCode={promotionCode}
                  setPromotionCode={setPromotionCode}
                  isCheckPromotionCode={isCheckPromotionCode}
                  toggleAskPromotionOn={toggleAskPromotionOn}
                  setToggleAskPromotionOn={setToggleAskPromotionOn}
                  setIsCheckPromotionCode={setIsCheckPromotionCode}
                  promotionApply={promotionApply}
                />
              </CommonFormProvider>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FiresidePromotionUI;
